import styled from 'styled-components'

const RawDataConfiguratorStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  .NumberInput {
    max-width: 5rem;
  }
  .FormField.Switch {
  }
`
export default RawDataConfiguratorStyled
